import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthBrand } from "../components/AuthBrand";
import { api, ApiError } from "../lib/api";

export function LoginPage() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await api.login(email.trim(), password);
      if (result.status === "mfa_enrollment_required") {
        navigate("/mfa/enroll", {
          state: {
            enrollmentToken: result.enrollmentToken,
            otpauthUri: result.otpauthUri,
            secret: result.secret,
          },
        });
      } else if (result.status === "mfa_required") {
        navigate("/mfa/verify", { state: { challengeToken: result.challengeToken } });
      } else {
        setUser(result.user);
        await refresh();
        navigate("/", { replace: true });
      }
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "ورود ناموفق بود");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <AuthBrand />
      <div className="auth-card">
        <h1>ورود به داشبورد</h1>
        <p className="auth-subtitle">حساب مدیریت محتوای پورتال</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>
            <span>ایمیل</span>
            <input
              type="email"
              dir="ltr"
              className="ltr-isolate"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </label>
          <label>
            <span>رمز عبور</span>
            <input
              type="password"
              dir="ltr"
              className="ltr-isolate"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          {error && <p className="form-error">{error}</p>}
          <button type="submit" className="btn btn--primary btn--block" disabled={submitting}>
            {submitting ? "در حال ورود…" : "ورود"}
          </button>
        </form>
      </div>
    </div>
  );
}
